<div class="login-page" *ngIf="!UserSignIn">  
  <div class="mf-login-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 col-sm-6 offset-md-3 login-form">
          <div>
            <div>
              <a class="login-logo">
                <img
                  src="../../assets/images/logo-bajaj-capital.png"
                  alt="BCL"
                  width="250"
                />
              </a>
            </div>
            <div class="card" [class.hidden]="passwordResetSuccess">
              <div class="card-body" *ngIf="isSignIn">
                <div class="tab-listing">
                  <div class="tab-list" *ngIf="clientId !== b2b_insurance && clientId !== retirment_clientid && clientId !== surveypro_clientid && clientId !== bqdashboard_clientid && clientId !== post_retirement_clientid && clientId !== b2b_india_bonds_clientid && clientId !== DatacloudWM_clientid && clientId !== fpb2b_clientid && clientId !== digitalrm_clientid">
                    <a
                      [routerLink]="['/sign-in']"
                      [queryParams]="{ clientId: clientId }"
                      data-target="login"
                      [class.active]="activeTab === 'sign-in'"
                      class="active"
                      >Login</a
                    >
                  </div>
                  <div class="tab-list" *ngIf="clientId !== b2b_insurance && clientId !== retirment_clientid  && clientId !== surveypro_clientid && clientId !== bqdashboard_clientid && clientId !== post_retirement_clientid && clientId !== b2b_india_bonds_clientid && clientId !== DatacloudWM_clientid && clientId !== fpb2b_clientid && clientId !== digitalrm_clientid">
                    <a
                      [routerLink]="['/sign-up']"
                      [queryParams]="{ clientId: clientId }"
                      data-target="sign_up"
                      [class.active]="activeTab === 'sign-up'"
                      >Sign Up</a
                    >
                  </div>
                  <div  class="tab-list" style="width: 100% !important" *ngIf="clientId === b2b_insurance || clientId === retirment_clientid || clientId === surveypro_clientid || clientId === bqdashboard_clientid || clientId === post_retirement_clientid || clientId === b2b_india_bonds_clientid || clientId === DatacloudWM_clientid ||  clientId === fpb2b_clientid || clientId === digitalrm_clientid">
                    <a
                      [routerLink]="['/sign-in']"
                      [queryParams]="{ clientId: clientId }"
                      data-target="login"
                      [class.active]="activeTab === 'rm-code'"
                      >Employee Login</a
                    >
                  </div>
                </div>
                <div class="tab-wrapper">
                  <div class="tab" id="login" style="display: block">
                    <div class="google-login" *ngIf="!hideGoogleLogin">
                      <a (click)="onGoogleSignIn()" style="cursor: pointer"
                        ><img
                          alt="Login with Google"
                          src="assets/images/google-icon.png"
                        /><span>Continue with Google</span></a
                      >
                    </div>
                    <div class="option-or" *ngIf="!hideGoogleLogin">Or</div>
                    <div id="main_loader" *ngIf="loader">
                      <div class="loader-wrapper">
                        <div class="lds-roller">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="activeTab == 'sign-in'">
                      <form class="" autocomplete="off">
                         <input type="text" name="fake-username" autocomplete="username" style="display:none" />
                        <input type="password" name="fake-password" autocomplete="new-password" style="display:none" />
                        <div class="form-group">
                          <label for="">Email/Mobile Number</label>
                          <input
                            type="email"
                            [(ngModel)]="username"
                            name="login-username"
                            (blur)="validateUsername()"
                            maxlength="50"
                            appEmailMobile
                            class="form-control"
                            placeholder="Please enter your Email/Mobile Number"
                          appBlockCopyPaste autocomplete="new-password"/>
                        </div>
                        <div class="form-group">
                          <label for="">Password</label>
                          <input
                            type="password"
                            [(ngModel)]="password"
                            name="login-password"
                            (blur)="validatePassword()"
                            maxlength="30"
                            class="form-control"
                            placeholder="Enter your password" appBlockCopyPaste  autocomplete="new-password"/>
                          <div class="otp-btn">
                            <a (click)="signinotp()" style="cursor: pointer"
                              >or login using OTP</a
                            >
                          </div>
                        </div>

                        <p *ngIf="signInErrorMessage" class="error-message">
                          {{ signInErrorMessage }}
                        </p>

                        <div class="text-center">
                          <button
                            type="submit"
                            class="btn btn-primary"
                            (click)="onSignIn()"
                          >
                            Login
                          </button>
                        </div>
                        <div class="text-center mt-3">
                          <p class="form-description">
                            <a
                              (click)="PasswordReset()"
                              class="forgot-password-link"
                              >Forgot password? Click here</a
                            >
                          </p>
                        </div>
                      </form>
                    </ng-container>
                    <ng-container *ngIf="activeTab == 'rm-code'">
                      <form class="" autocomplete="off">
                        <div class="form-group">
                          <label for="">RMcode/Email/Mobile Number</label>
                          <input
                            type="email"
                            [(ngModel)]="username2"
                            name="username"
                            (blur)="validateUsername2()"
                            maxlength="50"
                            class="form-control"
                            placeholder="Please enter your RMcode/Mobile Number/Email" appBlockCopyPaste autocomplete="off"/>
                        </div>
                        <div class="form-group">
                          <label for="">Password</label>
                          <input
                            type="password"
                            [(ngModel)]="password2"
                            name="password"
                            (blur)="validatePassword2()"
                            maxlength="30"
                            class="form-control"
                            placeholder="Enter your password" appBlockCopyPaste  autocomplete="new-password"/>
                          <div class="otp-btn">
                            <a (click)="signinotp()" style="cursor: pointer"
                              >or login using OTP</a
                            >
                          </div>
                        </div>

                        <p *ngIf="signInErrorMessage" class="error-message">
                          {{ signInErrorMessage }}
                        </p>

                        <div class="text-center">
                          <button
                            type="submit"
                            class="btn btn-primary"
                            (click)="b2bonSignIn()"
                          >
                            Login
                          </button>
                        </div>

                        <div class="text-center mt-3">
                          <p class="form-description">
                            <a
                              (click)="PasswordReset()"
                              class="forgot-password-link"
                              >Forgot password? Click here</a
                            >
                          </p>
                        </div>
                      </form>
                    </ng-container>
                  </div>
                </div>
              </div>

              <div class="card-body" *ngIf="isresetpassword && clientId !== b2b_insurance && clientId !== retirment_clientid && clientId !== surveypro_clientid && clientId !== bqdashboard_clientid && clientId !== post_retirement_clientid && clientId !== b2b_india_bonds_clientid && clientId !== DatacloudWM_clientid && clientId !== fpb2b_clientid && clientId !== digitalrm_clientid">
                <div id="main_loader" *ngIf="loader">
                  <div class="loader-wrapper">
                    <div class="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <form>
                  <h3>Forgot Password</h3>
                  <div class="alert alert-success">
                    To reset your password, simply enter your email.An OTP will
                    be sent on your registered e-mail Id.
                  </div>
                  <div class="form-group">
                    <label for="">Email</label>
                    <input
                      type="text"
                      id="resetEmail"
                      [(ngModel)]="email"
                      name="resetEmail"
                      maxlength="50"
                      class="form-control"
                      placeholder="Enter your Email" appBlockCopyPaste
                    />
                  </div>
                  
                  
              <p *ngIf="signInErrorMessage" class="error-message">
                <span [innerHTML]="signInErrorMessage"></span>

                <ng-container *ngIf="showCreateAccountLink">
                  <a *ngIf="clientId === b2b_insurance || clientId === retirment_clientid || clientId === surveypro_clientid || clientId === bqdashboard_clientid || clientId === post_retirement_clientid || clientId === b2b_india_bonds_clientid || clientId === DatacloudWM_clientid || clientId === fpb2b_clientid  || clientId === digitalrm_clientid"
                    class="link"
                    [href]="'/sign-in?clientId=' + clientId">
                  </a>

                  <a *ngIf="clientId !== b2b_insurance && clientId !== retirment_clientid && clientId !== surveypro_clientid && clientId !== bqdashboard_clientid && clientId !== post_retirement_clientid && clientId !== b2b_india_bonds_clientid && clientId !== DatacloudWM_clientid && clientId !== fpb2b_clientid && clientId !== digitalrm_clientid"
                    class="link"
                    [routerLink]="'/sign-up'"
                    [queryParams]="{ clientId: clientId }">
                    Create a new account.
                  </a>
                </ng-container>
              </p>

                  
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="onSendResetCode()"
                    >
                      Continue
                    </button>
                  </div>
                </form>
              </div>


                <div class="card-body" *ngIf="isresetpasswordb2b && (clientId === b2b_insurance || clientId === retirment_clientid || clientId === surveypro_clientid || clientId === bqdashboard_clientid || clientId === post_retirement_clientid || clientId === b2b_india_bonds_clientid || clientId === DatacloudWM_clientid || clientId === fpb2b_clientid || clientId === digitalrm_clientid)"> 
                <div id="main_loader" *ngIf="loader">
                  <div class="loader-wrapper">
                    <div class="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <form>
                  <h3>Forgot Password</h3>
                  <div class="alert alert-success">
                    To reset your password, simply enter your mobile.An OTP will
                    be sent on your registered Mobile Number.
                  </div>
                  <div class="form-group">
                    <label for="">Mobile</label>
                    <input
                      type="text"
                      id="mobile"
                      [(ngModel)]="mobile"
                      name="mobile"
                      maxlength="10"
                      appNumericDirective
                      class="form-control"
                      placeholder="Please enter your mobile" appBlockCopyPaste
                    />
                  </div>
                  <p *ngIf="signInErrorMessage" class="error-message">
                    {{ signInErrorMessage }}
                  </p>
                  
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="onSendResetCodeB2B()"
                    >
                      Continue
                    </button>
                  </div>
                </form>
              </div>

              <div class="card-body" *ngIf="isSignUpComplete && clientId !== b2b_insurance && clientId !== retirment_clientid && clientId !== surveypro_clientid && clientId !== bqdashboard_clientid && clientId !== post_retirement_clientid && clientId !== b2b_india_bonds_clientid && clientId !== DatacloudWM_clientid && clientId !== fpb2b_clientid && clientId !== digitalrm_clientid">
                <div id="main_loader" *ngIf="loader">
                  <div class="loader-wrapper">
                    <div class="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <form>
                  <h3>Generate New Password</h3>
                  <div class="form-group">
                    <label for="">OTP</label>
                    <input
                      type="text"
                      [(ngModel)]="confirmationCode"
                      name="confirmationCode"
                      maxlength="6"
                      class="form-control"
                      placeholder="Enter Verification Code" appBlockCopyPaste
                    />
                  </div>
                  <div class="form-group">
                    <label for="">New Password</label>
                    <input
                      id="newPassword"
                      [(ngModel)]="newPassword"
                      name="newPassword"
                      type="password"
                      required
                      maxlength="20"
                      class="form-control"
                      placeholder="Enter new password" appBlockCopyPaste
                    />

                    <p *ngIf="signInErrorMessage" class="red mt-2 d-block">
                      {{ signInErrorMessage }}
                    </p>
                  </div>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="onConfirmPasswordReset()"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>


            <div class="card-body" *ngIf="isconfirmpasswordb2b && (clientId === b2b_insurance || clientId === retirment_clientid || clientId === surveypro_clientid || clientId === bqdashboard_clientid || clientId === post_retirement_clientid || clientId === b2b_india_bonds_clientid || clientId === DatacloudWM_clientid || clientId === fpb2b_clientid || clientId === digitalrm_clientid)">
                <div id="main_loader" *ngIf="loader">
                  <div class="loader-wrapper">
                    <div class="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <form>
                  <h3>Generate New Password</h3>
                  <div class="form-group">
                    <label for="">OTP</label>
                    <input
                      type="text"
                      [(ngModel)]="confirmationCode"
                      name="confirmationCode"
                      maxlength="6"
                      class="form-control"
                      placeholder="Enter Verification Code" appBlockCopyPaste
                    />
                  </div>
                  <div class="form-group">
                    <label for="">New Password</label>
                    <input
                      id="newPassword"
                      [(ngModel)]="newPassword"
                      name="newPassword"
                      type="password"
                      required
                      maxlength="20"
                      class="form-control"
                      placeholder="Enter new password" appBlockCopyPaste
                    />

                    <p *ngIf="signInErrorMessage" class="red mt-2 d-block">
                      {{ signInErrorMessage }}
                    </p>
                  </div>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="onConfirmPasswordResetB2B()"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>

              <div class="card-body" *ngIf="signmobile">
                <div id="main_loader" *ngIf="loader">
                  <div class="loader-wrapper">
                    <div class="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <form>
                  <div
                    class="form-group"
                    style="margin-bottom: auto !important"
                  >
                    <label for="">Mobile</label>
                    <input
                      type="text"
                      id="mobile"
                      [(ngModel)]="mobile"
                      name="mobile"
                      maxlength="10"
                      appNumericDirective
                      class="form-control"
                      placeholder="Please enter your mobile" appBlockCopyPaste
                    />
                  </div>
                  <div class="otp-btn">
                    <a (click)="loginwithpassword()" style="cursor: pointer"
                      >or login using password</a
                    >
                  </div>
                  <p *ngIf="signInErrorMessage" class="error-message">
                    {{ signInErrorMessage }}
                  </p>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="initiateOTPSignIn()"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>

              <div class="card-body" *ngIf="signotp">
                <div id="main_loader" *ngIf="loader">
                  <div class="loader-wrapper">
                    <div class="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <form>
                  <div class="form-group">
                    <label for="">OTP</label>
                    <input
                      type="text"
                      id="otp"
                      [(ngModel)]="otp"
                      name="otp"
                      maxlength="6"
                      appOtp
                      class="form-control"
                      placeholder="Please enter your otp" appBlockCopyPaste
                    />
                  </div>
                  <p *ngIf="signInErrorMessage" class="error-message">
                    {{ signInErrorMessage }}
                  </p>
                  <p class="forgot-pass">
                    <a (click)="editMobile()" style="cursor: pointer"
                      >Edit Mobile</a
                    >
                  </p>
                  <p class="forgot-pass resend-link" *ngIf="resendotp">
                    <a (click)="initiateOTPSignIn()"  class="red mt-2 d-block"  style="cursor: pointer">Resend otp</a>
                  </p>
                  <div class="text-center">
                    <button
                      type="submit"
                      class="btn btn-primary"
                      (click)="verifyOTP()"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="login-page" *ngIf="UserSignIn">
  <div class="mf-login-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6 col-sm-6 offset-md-3 login-form">
          <div>
            <div>
              <a class="login-logo">
                <img
                  src="../../assets/images/logo-bajaj-capital.png"
                  alt="BCL"
                  width="250"
                />
              </a>
            </div>
            <div id="main_loader" *ngIf="loader">
              <div class="loader-wrapper">
                <div class="lds-roller">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>

            <div class="card2">
              <div class="card-body2">
                <h2 class="username">Welcome, {{ savedUserEmail }}</h2>
                <p class="welcome-message">
                  You are already signed in. Would you like to continue with the
                  same user or sign in as a different user?
                </p>
                <form>
                  <div class="form-group">
                    <div
                      class="google-login-Continue"
                      (click)="continueAsCurrentUser()"
                    >
                      <a
                        ><span> Continue as {{ savedUserEmail }}</span></a
                      >
                    </div>
                  </div>
                  <div class="option-or">Or</div>
                  <div class="google-login" (click)="handleSignOut()">
                    <a><span>Sign In as a different user</span></a>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="otpExpiredModal" class="popup-overlay" *ngIf="otpexpiredpop">
  <div class="popup-content">
    <h2>Password Expired!</h2>
    <p>
      Your password has expired. To reset it,
      <a (click)="PasswordReset()" class="clickable-link" style="color: #007BFF; cursor: pointer; text-decoration: underline">click here</a>.
    </p>
  </div>
</div>

<div id="otpExpiredModal" class="popup-overlay" *ngIf="expiredpop">
  <div class="popup-content">
    <h2>Password Expired!</h2>
    <p>
      Your password has expired. To reset it,
      <a
        (click)="PasswordReset()"
        class="clickable-link"
        style="color: #007bff; cursor: pointer; text-decoration: underline"
        onmouseover="this.style.color='#0056b3'"
        onmouseout="this.style.color='#007bff'"
        >click here</a
      >.
    </p>
  </div>
</div>

<div id="passwordResetModal" class="popup-overlay" *ngIf="passwordResetSuccess">
  <div class="popup-content">
    <div class="popup-icon success-icon"></div>
    <h2>Password Reset Successfully!</h2>
    <p>
      Your password has been reset. You can now log in with your new
      credentials.
    </p>
    <button class="popup-btn" (click)="ResetSucess()">Signin Now</button>
  </div>
</div>



<div id="userInactiveModal" class="popup-overlay" *ngIf="isUserInactive">
  <div class="popup-content">
    <div class="popup-icon error-icon"></div>
    <h2>Account Inactive</h2>
    <p>
      Your account is currently inactive. Please contact support or try again later.
    </p>
    <button class="popup-btn" (click)="handleInactiveUser()">OK</button>
  </div>
</div>

